import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { StatoIscritto, GruppoValore } from '../../model/iscritti-data';
import { RoleService } from '../../services/role.service';
import { ExportCasellarioFilters, ExportCasellarioItemDto, ExportCasellarioListDto } from '../../model/export-casellario-data';
import { ExportCasellarioService } from '../../services/export-casellario.service';

@Component({
  selector: 'app-export-casellario',
  templateUrl: './export-casellario.component.html',
  styleUrl: './export-casellario.component.scss'
})
export class ExportCasellarioComponent implements OnInit {
  @ViewChild('dt') dt!: Table;

  private route = inject(ActivatedRoute);
  private message_service = inject(MessageService);
  public role_service = inject(RoleService);
  private export_service = inject(ExportCasellarioService);

  tipoLista: string = '';
  componente: string = '';

  xlsSpinner: boolean = false;

  filtriForm: FormGroup|undefined;
  orderColumn: string = '';
  order: string = 'ASC';
  page: number = 0;
  pageSize: number = 25;
  first: number = 0;
  totaleDati: number = 0;

  statiDropdown: StatoIscritto[] | undefined;
  sezioniDropdown: GruppoValore[] = [
    { nome: 'Sezione A', valore: 'A' },
    { nome: 'Sezione B', valore: 'B' }
  ];

  headersTabella: string[] = ['Codice Fiscale', 'Nome', 'Cognome', 'Sezione', 'N° Iscrizione', 'Stato'];
  rowsTabella: string[] = ['codiceFiscale', 'nome', 'cognome', 'sezioneAlbo', 'numeroIscrizione', 'statoIscritto'];
  listaIscritti: ExportCasellarioItemDto[] = [];
  listaDaEsportare: ExportCasellarioItemDto[] = [];

  get iscrittiVisibili(): any[] {
    return this.listaIscritti;
  }

  ngOnInit(){
    this.statiDropdown = this.route.snapshot.data['statiIscritto'];
    this.componente = this.route.snapshot.data['componente'];
    this.createForm();
  }

  createForm(){
    this.filtriForm = new FormGroup({
      inserimento: new FormControl<string|null>(''),
      stato: new FormControl<number|null>(null),
      sezione: new FormControl<string|null>(null),
      dataIscrizioneDal: new FormControl<Date|null>(null),
      dataIscrizioneAl: new FormControl<Date|null>(null)
    });
    this.filtriForm.valueChanges.subscribe(() => {
      this.page = 0;
      this.first = 0;
      this.loadData();
    })
  }

  private loadData(){
    const data: ExportCasellarioFilters = this.getFilters();
    this.export_service.getIscrittiExport(data).subscribe({
      next: (result: ExportCasellarioListDto) => {
        this.listaIscritti = result.lista;
        this.totaleDati = result.conteggio;
      },
      error: () => {
        this.message_service.add({
          severity: 'error',
          summary: 'Qualcosa è andato storto',
          detail: 'Operazione interrotta.'
        });
      }
    })

  }
  
  getFilters(): ExportCasellarioFilters{
    const formValue = this.filtriForm!.getRawValue();
    return {
      orderColumn: this.orderColumn,
      order: this.order,
      page: this.page,
      pageSize: this.pageSize,
      inserimento: formValue.inserimento,
      stato: formValue.stato ? formValue.stato.id : null,
      sezione: formValue.sezione ? formValue.sezione.valore : null,
      dataIscrizioneDal: formValue.dataIscrizioneDal ? this.buildDate(formValue.dataIscrizioneDal) : null,
      dataIscrizioneAl: formValue.dataIscrizioneAl ? this.buildDate(formValue.dataIscrizioneAl) : null
    }
  }

  //assegna colore stato
  coloreStato(statoIscritto: string): string{
    let colore = '';
    if(statoIscritto == 'ATTIVO') colore = '#16A34A';
    if(statoIscritto == 'SOSPESO') colore = '#CDC103';
    if(statoIscritto == 'TRASFERIMENTO') colore = '#00BFFE';
    return colore;
  }

  //cambio pagina della tabella
  pageChange(event: any){
    this.first = event.first;
    this.page = event.page;
    this.pageSize = event.rows;
    this.loadData();
  }
  ordinamento(event: any){
    this.orderColumn = event.sortField ? event.sortField : 'codiceFiscale';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.page = 0;
    this.pageSize = 25;
    this.loadData();
  }
  orderCustom(order: string): number{
    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;
    return check;
  }
  resetBoxRicerca(){
    this.filtriForm!.get('inserimento')?.setValue('');
  }
  clearFilters(){
    this.filtriForm!.reset();
    this.resetPagination();
    this.dt.reset();
    this.loadData();
  }
  resetPagination(){
    this.orderColumn = 'codiceFiscale';
    this.order = 'ASC';
    this.page = 0;
    this.pageSize = 25;
    this.first = 0;
  }

  selezioneMassiva(check: any){
    if(check.checked){
      this.listaDaEsportare = [...this.listaDaEsportare, ...this.listaIscritti];
    }
    else{
      for(let iscritto of this.listaIscritti){
        this.listaDaEsportare = this.listaDaEsportare.filter(item => item.id != iscritto.id);
      }
    }
  }
  checkAllSelezionati(){
    for(let iscritto of this.listaIscritti){
      const item = this.listaDaEsportare.find(isc => isc.id == iscritto.id);
      if(item == null){
        return false;
      }
    }
    return true;
  }
  selezionaSingolo(iscritto: ExportCasellarioItemDto, check: any){
    if(check.checked){
      this.listaDaEsportare.push(iscritto);
    }
    else{
      this.listaDaEsportare = this.listaDaEsportare.filter(item => item.id != iscritto.id);
    }
  }
  checkSelezionato(iscritto: ExportCasellarioItemDto){
    return this.listaDaEsportare.find(item => item.id == iscritto.id) ? true : false;
  }

  generaCsv(){
    if(this.listaDaEsportare && this.listaDaEsportare.length > 0){
      this.xlsSpinner = true;
      this.export_service.esporta(this.listaDaEsportare).subscribe({
        next: blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'casellario_iscritti.csv';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.xlsSpinner = false;
          this.listaDaEsportare = [];
        },
        error: err => {
          this.message_service.add({
            severity: 'error',
            summary: 'Qualcosa è andato storto',
            detail: 'Operazione interrotta.'
          });
          console.error('Error downloading the file', err);
          this.xlsSpinner = false;
        }
      });
    }
    else{
      this.message_service.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Devi selezionare almeno un iscritto'
      });
    }
  }

  buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());
    const data = `${year}-${month}-${day}`;
    return data;
  }
}
